module.exports = require('debug');